const QUESTION_TYPES = {
  MULTIPLE_CHOICE: 1,
  TRUE_FALSE: 2,
  YES_NO: 3,
  DESCRIPTION_MULTIPLE_CHOICE: 4,
  MULTISELECT_MULTIPLE_CHOICE: 5
};

module.exports = QUESTION_TYPES;
